import { db, type LocalMomentTagsAndEmotions } from './db'

export const storeMomentTagsAndEmotionsPayload = async (
  payload: LocalMomentTagsAndEmotions,
) => {
  await db.momentTagsAndEmotions.add(payload)
}

export const getMomentTagsAndEmotionsPayload = async () => {
  const payload = await db.momentTagsAndEmotions.toArray()
  return payload
}

export const deleteMomentTagsAndEmotionsPayload = async () => {
  await db.momentTagsAndEmotions.clear()
}

export const deleteMomentTagsAndEmotionsPayloadById = async (id: number) => {
  await db.momentTagsAndEmotions.delete(id)
}
